import { JoinedDimensions } from '../../../../config/utils/models';
import FormattedMessage from '../../../../config/components/TranslationWrapper';
import globalMessages from '../../../../config/globalMessages';

const zincFields = [
  { ...JoinedDimensions.fields.id, width: 0.4, isFilterable: true },
  { ...JoinedDimensions.fields.actualId, width: 0.4, isFilterable: true },
  { ...JoinedDimensions.fields.orderImportNumber, width: 1, isFilterable: true },
  { ...JoinedDimensions.fields.assignedPress, width: 0.4, isFilterable: true },
  { ...JoinedDimensions.fields.orderIdSmartlam, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.rawDimensionsConvertedLengthInFeet, width: 0.75, isFilterable: true },
  { ...JoinedDimensions.fields.planedDimensionsConverted, width: 0.5, isFilterable: true },
  { ...JoinedDimensions.fields.rigidplyQuality, width: 0.5, isFilterable: true },
  { ...JoinedDimensions.fields.woodType, width: 0.5, isFilterable: true },
  { ...JoinedDimensions.fields.splitThickness, width: 0.35, isFilterable: true },
  { ...JoinedDimensions.fields.outsideLam, width: 0.35, isFilterable: false },
  { ...JoinedDimensions.fields.zincDoneNumLamellas, width: 0.35, isFilterable: true },
  { ...JoinedDimensions.fields.numLamellas, width: 0.35, isFilterable: true },
  { ...JoinedDimensions.fields.piecesPerLam, width: 0.35, isFilterable: true },
  { ...JoinedDimensions.fields.floorStoragePosition, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.leftMaterialStorage, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.startSequence, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.endSequence, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.combinedOrderColor, width: 0.3, isFilterable: false },
  { ...JoinedDimensions.actions.moveUpNoCompareSchneider, width: 0.3, isFilterable: false },
  { ...JoinedDimensions.actions.moveDownNoCompareSchneider, width: 0.3, isFilterable: false },
  { ...JoinedDimensions.actions.editJDWithoutAdmin, width: 0.3, isFilterable: false },
  { ...JoinedDimensions.actions.deleteConfirmRepairOrder, width: 0.3, isFilterable: false }
];

const planerFields = [
  { ...JoinedDimensions.fields.id, width: 0.5, isFilterable: true },
  { ...JoinedDimensions.fields.group, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.orderImportNumber, width: 0.7, isFilterable: true },
  { ...JoinedDimensions.fields.orderIdSmartlam, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.rawDimensionsConvertedLengthInFeet, width: 0.7, isFilterable: true },
  { ...JoinedDimensions.fields.planedDimensionsConverted, width: 0.7, isFilterable: true },
  { ...JoinedDimensions.fields.quality, width: 0.6, isFilterable: true },
  { ...JoinedDimensions.fields.woodType, width: 0.6, isFilterable: true },
  { ...JoinedDimensions.fields.position, width: 0.6, isFilterable: true },
  { ...JoinedDimensions.fields.splitThickness, width: 0.7, isFilterable: true },
  { ...JoinedDimensions.fields.doneOnPlaner, width: 0.5, isFilterable: true },
  { ...JoinedDimensions.fields.numLamellas, width: 0.5, isFilterable: true },
  { ...JoinedDimensions.fields.piecesPerLam, width: 0.5, isFilterable: true },
  { ...JoinedDimensions.fields.startSequence, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.endSequence, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.fields.combinedOrderColor, width: 0.3, isFilterable: true },
  { ...JoinedDimensions.actions.moveUpNoCompareSchneider, width: 0.3, isFilterable: false },
  { ...JoinedDimensions.actions.moveDownNoCompareSchneider, width: 0.3, isFilterable: false },
  { ...JoinedDimensions.actions.editJDWithoutAdmin, width: 0.3, isFilterable: false },
  { ...JoinedDimensions.actions.deleteConfirmRepairOrder, width: 0.3, isFilterable: false }
];

const colorsZink = function (item) {
  const colorMap = [
    { condition: item?.producingOnZinc, color: 'rgba(19, 101, 160, 0.5)' },
    { condition: item?.currentlyLoadingMaterialFor, color: 'rgba(255, 192, 103, 0.5)' },
    { condition: item?.finishedProducingOnZinc, color: 'rgba(24, 89, 41, 0.5)' },
    { condition: item?.enoughRawMaterial, color: 'rgba(196, 217, 231, 0.7)' },
    { condition: item?.switchDimension, color: 'rgba(196, 164, 132, 0.7)' },
    { condition: item?.forceSwitchDimension, color: 'rgba(184, 124, 76, 0.7)' }
  ];

  const colors = colorMap.filter(({ condition }) => condition).map(({ color }) => color);
  return colors.length ? colors : ['#FFFFFF'];
};

const colorsPlaner = function (item) {
  const colorMap = [
    { condition: item?.onPlaner, color: 'rgb(139 195 75 / 33%)' },
    { condition: item?.finishedOnPlaner, color: 'rgb(139 195 75 / 73%)' }
  ];

  const colors = colorMap.filter(({ condition }) => condition).map(({ color }) => color);
  return colors.length ? colors : ['#FFFFFF'];
};

const groupColorsZink = {
  finishedProducingOnZinc: 'rgba(202, 255, 216, 0.5)',
  producingOnZinc: 'rgba(219, 240, 247, 0.5)'
};

const coloringFieldKeysZink = ['currentlyLoadingMaterialFor', 'producingOnZinc', 'finishedProducingOnZinc'];
const childColoringFieldKeys = ['producingOnZPress', 'finishedProducingOnZPress'];

const searchFilterOptions = [
  { value: 'id', label: <FormattedMessage id="id" defaultMessage="ID" /> },
  { value: 'orderId', label: <FormattedMessage id="orderId" defaultMessage="Order ID" /> }
];

const label = <FormattedMessage {...globalMessages.machine} identifier={'machine'} />;

const defaultJdQueueConfig = {
  selectState: 'zink',
  zincFields,
  orderFields: zincFields,
  colors: colorsZink,
  groupColors: groupColorsZink,
  coloringFieldKeys: coloringFieldKeysZink,
  label,
  data: {
    emptyFromVacuumToZink: false,
    productionSequenceHashCode: '',
    status: null
  },
  selectView: true,
  searchFilterOptions,
  selectOptions: {
    zink: {
      string: 'Zink',
      data: zincFields,
      colors: colorsZink,
      groupColors: groupColorsZink,
      coloringFieldKeys: coloringFieldKeysZink,
      tableIndexVariable: 'jdPosition',
      showButtons: ['missing-lamella-request', 'extra-lamella-request'],
      childColoringFieldKeys
    },
    planer: {
      string: 'Planer',
      data: planerFields,
      colors: colorsPlaner,
      groupColors: groupColorsZink,
      coloringFieldKeys: coloringFieldKeysZink,
      tableIndexVariable: 'planerPosition',
      showButtons: ['missing-lamella-request', 'extra-lamella-request'],
      childColoringFieldKeys
    }
  }
};

export default defaultJdQueueConfig;
